import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue';
import { CategoryFourthLevel } from '@/shared/dtos/category-fourth-level';
import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';



@Module({
    namespaced: true,
    name: 'CategoryFourthLevelModule',
    store,
    dynamic: true,
})

class CategoryFourthLevelModule extends VuexModule implements BaseModule {
    public categories: CategoryFourthLevel[] = [];

    @Mutation
    public resetState(): void {
        this.categories = [];
    }



    @Action
    public async getCategoriesFourthLevel() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.categoryFourthLevel);
        this.context.commit('updateCategoriesFourthLevel', res);
    }

    @Mutation
    public updateCategoriesFourthLevel(items: CategoryFourthLevel[]) {
        this.categories = items.map(x => new CategoryFourthLevel(x));
    }

    @Action
    public async insertarCategoryFourthLevel(item: CategoryFourthLevel) {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.post(API.categoryFourthLevel, item, false);
        this.context.dispatch('getCategoriesFourthLevel');
    }

    @Action
    public async modificarCategoryFourthLevel(item: CategoryFourthLevel) {
        if (!itiTokenService.hasToken()) { return; }
        //const apiUpdateCategory = ItiString.Format(API.categoryFourthLevelDetail, item.id);
        try {
            const res = await itiHttpService.put(API.categoryFourthLevel, item, false);
        } catch {
            // ...
        }
        this.context.dispatch('getCategoriesFourthLevel');
    }

    @Action
    public async eliminarCategoryFourthLevel(id: number) {
        if (!itiTokenService.hasToken()) { return; }
        const apiDeleteCategory = ItiString.Format(API.categoryFourthLevelDetail, id);
        const res = await itiHttpService.delete(apiDeleteCategory, id, false);
        this.context.dispatch('getCategoriesFourthLevel');
    }
}

export default getModule(CategoryFourthLevelModule);